import { render } from "./ImageManager.vue?vue&type=template&id=2c0119d9&scoped=true"
import script from "./ImageManager.vue?vue&type=script&lang=js"
export * from "./ImageManager.vue?vue&type=script&lang=js"

import "./ImageManager.vue?vue&type=style&index=0&id=2c0119d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0119d9"]])

export default __exports__